import { j as t } from "./jsx-runtime-C5mzlN2N.js";
import { c as z, L as D, e as H, i as U } from "./chunk-KNED5TY2-BUPjb3LQ.js";
import { UnlinkIcon as V, CheckIcon as W, CopyIcon as q } from "lucide-react";
import { C as Z } from "./CategoryHeading-D06WK_Wo.js";
import { Callout as G } from "./ui/Callout.js";
import { M as X, H as b, P as I } from "./Markdown-DqDbGCj2.js";
import { P as B, t as g, H as J } from "./SyntaxHighlight-CxhyyMkF.js";
import { z as K } from "./index-DwT-v3zK.js";
import w, { memo as Q, useState as ee, useContext as re } from "react";
import { C } from "./ClientOnly-E7hGysn1.js";
import { c as R } from "./cn-qaFjX9_3.js";
import { Z as P } from "./invariant-Caa8-XvF.js";
import { u as te } from "./useExposedProps-Dq2yUQIG.js";
const O = ({
  children: r,
  className: s
}) => {
  if (process.env.NODE_ENV === "development")
    return /* @__PURE__ */ t.jsx(G, { type: "caution", title: "Developer hint", className: s, children: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
      typeof r == "string" ? /* @__PURE__ */ t.jsx(X, { content: r }) : /* @__PURE__ */ t.jsx("div", { children: r }),
      /* @__PURE__ */ t.jsx("small", { className: "italic", children: "Note: This hint is only shown in development mode." })
    ] }) });
}, oe = () => {
  const r = z();
  return /* @__PURE__ */ t.jsxs("div", { className: I + " h-full pt-[--padding-content-top]", children: [
    /* @__PURE__ */ t.jsx(Z, { children: "404" }),
    /* @__PURE__ */ t.jsxs(b, { level: 1, className: "flex gap-3.5 items-center", children: [
      "Page not found",
      /* @__PURE__ */ t.jsx(V, { size: 24 })
    ] }),
    /* @__PURE__ */ t.jsxs(O, { children: [
      "Start by adding a file at",
      " ",
      /* @__PURE__ */ t.jsxs("code", { children: [
        "{PROJECT_ROOT}",
        "/",
        r["*"],
        ".mdx"
      ] }),
      " ",
      "and add some content to make this error go away."
    ] }),
    /* @__PURE__ */ t.jsx("p", { children: "It seems that the page you are looking for does not exist or may have been moved. Please check the URL for any typos or use the navigation menu to find the correct page." }),
    /* @__PURE__ */ t.jsx(D, { to: "/", children: "Go back home" })
  ] });
};
globalThis.Prism = B;
import("./prism-bash.min-HHIMdNJ_.js");
import("./prism-ruby.min-L9OdQ6tU.js").then((r) => r.p);
import("./prism-markup-BNGj0Tvm.js");
import("./prism-json.min-B1GJqK1k.js");
import("./prism-java.min-CQzr40NQ.js").then((r) => r.p);
import("./prism-csharp.min-C43x1RY2.js").then((r) => r.p);
import("./prism-objectivec.min-BXSWqpJJ.js");
import("./prism-markdown.min-C0Qn0m-5.js");
import("./prism-javascript.min-CEqHqgbm.js");
import("./prism-typescript.min-qTySPvCh.js").then((r) => r.p);
import("./prism-jsstacktrace.min-BfobCF2F.js");
const ne = {
  mdx: "md"
}, se = ({
  language: r = "plain",
  showCopy: s = "hover",
  showCopyText: a,
  title: l,
  children: m,
  disabled: f,
  ...i
}) => {
  const { resolvedTheme: p } = K(), [d, E] = ee(!1), u = m ?? i.code;
  if (!u)
    return null;
  const h = p === "dark" ? g.vsDark : g.github, T = "bg-[#f6f8fa] text-[#393a34] dark:bg-[#1e1e1e] dark:text-[#9cdcfe]", _ = ({
    children: c,
    className: e,
    style: x
  }) => /* @__PURE__ */ t.jsxs("div", { className: "relative group", children: [
    l && /* @__PURE__ */ t.jsx("div", { className: "text-xs text-muted-foreground absolute top-2 font-mono border-b w-full pb-2 px-4 ", children: l }),
    /* @__PURE__ */ t.jsx(
      "pre",
      {
        className: R(
          "relative scrollbar overflow-x-auto",
          i.className,
          i.noBackground ? "!bg-transparent" : T,
          i.wrapLines && "whitespace-pre-wrap break-words",
          l && "pt-10",
          e
        ),
        style: x,
        children: c
      }
    ),
    i.showLanguageIndicator && /* @__PURE__ */ t.jsx("span", { className: "absolute top-1.5 right-3 text-[11px] font-mono text-muted-foreground transition group-hover:opacity-0", children: r }),
    s !== "never" && /* @__PURE__ */ t.jsxs(
      "button",
      {
        type: "button",
        "aria-label": "Copy code",
        title: "Copy code",
        className: R(
          "absolute top-2 right-2 p-2  hover:outline hover:outline-border/75 dark:hover:outline-border rounded-md text-sm text-muted-foreground transition",
          s === "hover" ? "opacity-0 group-hover:opacity-100 group-hover:bg-zinc-100 group-hover:dark:bg-zinc-700" : "bg-zinc-100 dark:bg-zinc-700",
          a && "flex gap-2 items-center font-medium"
        ),
        disabled: d,
        onClick: () => {
          E(!0), navigator.clipboard.writeText(u), setTimeout(() => E(!1), 2e3);
        },
        children: [
          d ? /* @__PURE__ */ t.jsx(
            W,
            {
              className: "text-emerald-600",
              size: 16,
              strokeWidth: 2.5,
              absoluteStrokeWidth: !0
            }
          ) : /* @__PURE__ */ t.jsx(q, { size: 16 }),
          a && "Copy"
        ]
      }
    )
  ] });
  return f ? /* @__PURE__ */ t.jsx(C, { fallback: /* @__PURE__ */ t.jsx(_, { children: u }), children: /* @__PURE__ */ t.jsx(_, { children: u }) }) : /* @__PURE__ */ t.jsx(C, { fallback: /* @__PURE__ */ t.jsx(_, { children: u }), children: /* @__PURE__ */ t.jsx(
    J,
    {
      theme: h,
      language: ne[r] ?? r,
      ...i,
      code: u,
      children: ({ className: c, style: e, tokens: x, getLineProps: k, getTokenProps: L }) => /* @__PURE__ */ t.jsx(_, { className: c, style: e, children: x.map((S, M) => (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ t.jsx("div", { ...k({ line: S }), children: S.map((F, j) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ t.jsx("span", { ...L({ token: F }) }, j)
        )) }, M)
      )) })
    }
  ) });
}, Y = Q(se);
Y.displayName = "SyntaxHighlight";
function ie({ error: r }) {
  const s = r instanceof Error ? r.message : "Something went wrong", a = r instanceof P ? r.developerHint : void 0, l = r instanceof P ? r.title : "Something went wrong", m = r instanceof Error ? r.stack : void 0, f = r instanceof Error ? r.cause : void 0, i = f instanceof Error ? String(f.stack) : m;
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: R(
        I,
        "grid grid-cols-1 !max-w-none pt-[--padding-content-top]"
      ),
      children: [
        /* @__PURE__ */ t.jsx(b, { level: 1, children: l }),
        "Error: ",
        s,
        a && /* @__PURE__ */ t.jsx(O, { className: "mb-4", children: a }),
        i && /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
          Y,
          {
            className: "max-h-[400px] border mt-2",
            language: "jsstacktrace",
            code: i
          }
        ) })
      ]
    }
  );
}
function Ce() {
  const r = H();
  return U(r) && r.status === 404 ? /* @__PURE__ */ t.jsx(oe, {}) : /* @__PURE__ */ t.jsx(ie, { error: r });
}
var v = { exports: {} }, o = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var y;
function ae() {
  if (y) return o;
  y = 1;
  var r = Symbol.for("react.transitional.element"), s = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), m = Symbol.for("react.profiler"), f = Symbol.for("react.consumer"), i = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), T = Symbol.for("react.view_transition"), _ = Symbol.for("react.client.reference");
  function c(e) {
    if (typeof e == "object" && e !== null) {
      var x = e.$$typeof;
      switch (x) {
        case r:
          switch (e = e.type, e) {
            case a:
            case m:
            case l:
            case d:
            case E:
            case T:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case i:
                case p:
                case h:
                case u:
                  return e;
                case f:
                  return e;
                default:
                  return x;
              }
          }
        case s:
          return x;
      }
    }
  }
  return o.ContextConsumer = f, o.ContextProvider = i, o.Element = r, o.ForwardRef = p, o.Fragment = a, o.Lazy = h, o.Memo = u, o.Portal = s, o.Profiler = m, o.StrictMode = l, o.Suspense = d, o.SuspenseList = E, o.isContextConsumer = function(e) {
    return c(e) === f;
  }, o.isContextProvider = function(e) {
    return c(e) === i;
  }, o.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === r;
  }, o.isForwardRef = function(e) {
    return c(e) === p;
  }, o.isFragment = function(e) {
    return c(e) === a;
  }, o.isLazy = function(e) {
    return c(e) === h;
  }, o.isMemo = function(e) {
    return c(e) === u;
  }, o.isPortal = function(e) {
    return c(e) === s;
  }, o.isProfiler = function(e) {
    return c(e) === m;
  }, o.isStrictMode = function(e) {
    return c(e) === l;
  }, o.isSuspense = function(e) {
    return c(e) === d;
  }, o.isSuspenseList = function(e) {
    return c(e) === E;
  }, o.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === a || e === m || e === l || e === d || e === E || typeof e == "object" && e !== null && (e.$$typeof === h || e.$$typeof === u || e.$$typeof === i || e.$$typeof === f || e.$$typeof === p || e.$$typeof === _ || e.getModuleId !== void 0);
  }, o.typeOf = c, o;
}
var n = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N;
function ce() {
  return N || (N = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (typeof e == "object" && e !== null) {
        var x = e.$$typeof;
        switch (x) {
          case s:
            switch (e = e.type, e) {
              case l:
              case f:
              case m:
              case E:
              case u:
              case _:
                return e;
              default:
                switch (e = e && e.$$typeof, e) {
                  case p:
                  case d:
                  case T:
                  case h:
                    return e;
                  case i:
                    return e;
                  default:
                    return x;
                }
            }
          case a:
            return x;
        }
      }
    }
    var s = Symbol.for("react.transitional.element"), a = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), m = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), p = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), _ = Symbol.for("react.view_transition"), c = Symbol.for("react.client.reference");
    n.ContextConsumer = i, n.ContextProvider = p, n.Element = s, n.ForwardRef = d, n.Fragment = l, n.Lazy = T, n.Memo = h, n.Portal = a, n.Profiler = f, n.StrictMode = m, n.Suspense = E, n.SuspenseList = u, n.isContextConsumer = function(e) {
      return r(e) === i;
    }, n.isContextProvider = function(e) {
      return r(e) === p;
    }, n.isElement = function(e) {
      return typeof e == "object" && e !== null && e.$$typeof === s;
    }, n.isForwardRef = function(e) {
      return r(e) === d;
    }, n.isFragment = function(e) {
      return r(e) === l;
    }, n.isLazy = function(e) {
      return r(e) === T;
    }, n.isMemo = function(e) {
      return r(e) === h;
    }, n.isPortal = function(e) {
      return r(e) === a;
    }, n.isProfiler = function(e) {
      return r(e) === f;
    }, n.isStrictMode = function(e) {
      return r(e) === m;
    }, n.isSuspense = function(e) {
      return r(e) === E;
    }, n.isSuspenseList = function(e) {
      return r(e) === u;
    }, n.isValidElementType = function(e) {
      return typeof e == "string" || typeof e == "function" || e === l || e === f || e === m || e === E || e === u || typeof e == "object" && e !== null && (e.$$typeof === T || e.$$typeof === h || e.$$typeof === p || e.$$typeof === i || e.$$typeof === d || e.$$typeof === c || e.getModuleId !== void 0);
    }, n.typeOf = r;
  }()), n;
}
var A;
function le() {
  return A || (A = 1, process.env.NODE_ENV === "production" ? v.exports = /* @__PURE__ */ ae() : v.exports = /* @__PURE__ */ ce()), v.exports;
}
var ue = /* @__PURE__ */ le();
const $ = w.createContext({}), Pe = ({
  slotlets: r,
  children: s
}) => /* @__PURE__ */ t.jsx($.Provider, { value: r, children: s }), ye = ({ name: r }) => {
  const s = re($), a = s == null ? void 0 : s[r], l = te();
  return ue.isValidElementType(a) ? w.createElement(a, l) : a;
};
export {
  O as D,
  ie as E,
  Ce as R,
  ye as S,
  Pe as a
};
//# sourceMappingURL=SlotletProvider-p4XaFFOh.js.map
